import { createFileRoute } from "@tanstack/react-router";
import { AgentConfigRoute } from "@/components/agents/agents-workbench";
import { useAgents, useWorkspaceRoot } from "@/lib/api";

export const Route = createFileRoute("/$owner/agents/$agentId/models")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
		void queryClient.prefetchQuery(useAgents.queryOptions(params.owner));
	},
	component: AgentModelsPage,
});

function AgentModelsPage() {
	const { owner, agentId } = Route.useParams();
	return <AgentConfigRoute owner={owner} agentId={agentId} tab="models" />;
}
